import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { LoadingService } from "../services/loading.service";
import { IGNORAR_LOADING } from "./ignorar-loading";

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private activeRequests = 0;
  
  constructor(private loadingService: LoadingService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    
    if (req.context.get(IGNORAR_LOADING) || this.loadingService.isUrlExcluded(req.url)) {
      return next.handle(req);
    }
    
    this.activeRequests++;

    setTimeout(() => {
      this.loadingService.setLoading(true);
    }, 0);

    return next.handle(req).pipe(
      finalize(() => {
        this.activeRequests = Math.max(0, this.activeRequests - 1);

        setTimeout(() => {
          if (this.activeRequests === 0) {
            this.loadingService.setLoading(false);
          }
        }, 0);
      })
    );
  }

  resetActiveRequests(): void {
    this.activeRequests = 0;
  }
}